import React from 'react'

import { CircleCheck, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { oneOf } from 'prop-types'

import { iconSize, MODE } from 'Pods/LazyLoaded/AiSignInModal/constants'

function SuccessStep({ mode }) {
  const subtitle = mode === MODE.LOGIN
    ? 'You are logged in. Pick up where you left off!'
    : 'Account created. Generate your first 3D model!'

  return (
    <div className="ai-sign-in-modal__success">
      <span className="ai-sign-in-modal__success-icon">
        <Icon svgComponent={CircleCheck} size={iconSize} notSpaced />
      </span>
      <div className="ai-sign-in-modal__header-group ai-sign-in-modal__header-group--center">
        <p className="ai-sign-in-modal__title cgt-heading-300">You are in!</p>
        <p className="ai-sign-in-modal__subtitle cgt-body-md">{subtitle}</p>
      </div>
    </div>
  )
}

SuccessStep.propTypes = {
  mode: oneOf([MODE.SIGNUP, MODE.LOGIN]).isRequired,
}

export default SuccessStep
